"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const Button_js_1 = require("../CustomButtons/Button.js");
function ImageUpload(props) {
    const { accept = "*", className = "", imagePreviewUrl, file, fileInput, handleClick, handleRemove, onChange } = props;
    let { avatar, addButtonProps, changeButtonProps, removeButtonProps } = props;
    return (React.createElement("div", { className: "fileinput text-center" },
        React.createElement("input", { type: "file", accept: accept, onChange: onChange, ref: fileInput }),
        React.createElement("div", { className: "thumbnail" + (avatar ? " img-circle" : "") },
            React.createElement("img", { className: className, src: imagePreviewUrl, alt: "..." })),
        React.createElement("div", null, file === null ? (React.createElement(Button_js_1.default, Object.assign({}, addButtonProps, { onClick: handleClick }), avatar ? "Add Photo" : "Select image")) : (React.createElement("span", null,
            React.createElement(Button_js_1.default, Object.assign({}, changeButtonProps, { onClick: handleClick }), "Change"),
            avatar ? React.createElement("br", null) : null,
            React.createElement(Button_js_1.default, Object.assign({}, removeButtonProps, { onClick: handleRemove }), "Remove"))))));
}
exports.default = ImageUpload;
//# sourceMappingURL=ImageUpload.js.map